<template>
  <div class="research-system flex-cl">
    <div class="header flex-cl"></div>
    <div class="research-main">
      <div class="content">
        <div class="research-title">
          <div><img src="./images/research-title.png" alt="" /></div>
          <p style="margin: 51px 0px 20px;">亚洲商务大学堂提供四个层级的研修体系，其中包括高阶研修班、中阶研修班、进阶研修班和合作伙伴研修班</p>
          <p style="padding-bottom: 161px;">AAB offers four levels of courses, including Advanced Courses, Intermediate Courses, Introductory Training Courses, and Partner Courses</p>
          <div class="advance"><img src="./images/advance.png" alt="" /></div>
        </div>
        <div class="flex-row">
          <div class="flex-cl">
            <div :class="[titleAction == index ? 'title pitch-title': 'title']" v-for="(item, index) in researchSystemList" :key="item.title" @click="titleAction = index">
              <img :src="require(`./images/${titleAction == index ? item.title: item.pitchTitle}`)" />
            </div>
          </div>
          <div class="text" v-if="titleAction === index" v-for="(item, index) in researchSystemList" :key="item.title">
            <p>{{item.content}}</p><br />
            <p style="font-size: 14px;">{{item.enContent}}</p>
          </div>
        </div>
      </div>
    </div>
    <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
export default {
  name: "ResearchSystem",
  components: {
    goTop
  },
  data() {
    return {
      researchSystemList: [
        {
          title: 'main-pitch-title1.png',
          pitchTitle: 'main-title1.png',
          content: '对标松下政经塾，“亚商99”基于如斯而成的社会责任感，将精心挑选符合条件的青年企业家，秉承“因人制宜、量身定制、精准滴灌”的私教研修方法，赋能打造真正具备“中国老钱（old money）”质地，领军未来、传承有序、持续成长的新一代产业和社会财富的领军人物。',
          enContent: 'In alignment with the The Matsushita Institute of Politocs and Management, the "Asia+ Business 99" program, rooted in a strong sense of social responsibility, meticulously selects eligible young entrepreneurs. Following a tailored and precise approach characterized by "personalization, customization, and targeted mentoring," this private education and training initiative empower participants to cultivate the authentic qualities of "old money" in China. The program aims to nurture a new generation of leaders who will spearhead future industries, uphold orderly succession, and contribute to the sustained growth of both industrial and societal wealth.'
        },
        {
          title: 'main-pitch-title2.png',
          pitchTitle: 'main-title2.png',
          content: '沿袭掌门人正经塾的模式，带领学员游学国内外业界龙头大咖，打开心扉和视野，加深对商业机会的广度和深度的理解，并在互动式学习交流中提升自己的事业。',
          enContent: 'Following the model of the "Zheng Jing Shu", these courses encourage students to travel around the world, visit industry leaders, and deepen their understanding of the global market.'
        },
        {
          title: 'main-pitch-title3.png',
          pitchTitle: 'main-title3.png',
          content: '基于案例和前沿趋势的完全实战导向的研修，相关大咖导师和企业家、投资大师现场指导互动，注重实际获得感 。',
          enContent: 'These courses feature efficient face-to-face interactions with successful entrepreneurs and investment experts, promising an exciting and impactful learning experience.'
        },
        {
          title: 'main-pitch-title4.png',
          pitchTitle: 'main-title4.png',
          content: '与国内外各大高校商学院校友会、企业家协会和高客服务平台等专业机构，基于合作课程而建立有效联系网络，丰富学员资源圈。',
          enContent: "Establishing extensive connections with universities, alumni associations, and entrepreneurial groups worldwide, these courses enrich students\' learning resources."
        }
      ],
      titleAction: 0
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.textOneByOne();
    });
  }
}
</script>

<style scoped>
.research-system{
  width: 100vw;
  min-width: 1200px;
  position: relative;
}
.research-system .header{
  width: 100%;
  height: 400px;
  background: url("./images/header.png") no-repeat center center;
  background-size: cover;
}
.research-system .research-main{
  height: 1064px;
  background: url("./images/bg.png") no-repeat center center;
}
.research-system .content {
  width: 1200px;
  margin: 0 auto;
  padding: 107px 0 96px 0;
}
.research-system .content .flex-row {
  display: flex;
  flex-flow: row;
}
.research-system .flex-cl {
  display: flex;
  flex-flow: column;
}
.research-system .flex-cl .title{
  width: 474px;
  height: 119px;
  padding: 0 54px;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid #F7F8FA;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: FZQingKeBenYueSongS-R-GB;
  font-size: 18px;
  color: #003B83;
  line-height: 29px;
  cursor: pointer;
}
.research-system .flex-cl .pitch-title{
  color: #FFFFFF;
  border: initial;
  background: url("./images/title-bg.png") no-repeat 0 0;
  background-size: cover;
}
.research-system .content .text{
  flex: 1;
  background: url("./images/text-bg.png") no-repeat 0 0;
  background-size: cover;
  padding: 96px 20px 25px;
  box-sizing: border-box;
  font-family: Source Han Sans CN;
  font-size: 18px;
  color: #FFFFFF;
  text-align: left;
  line-height: 27px;
}
.research-system .research-title{
  position: relative;
  text-align: left;
}
.research-system .research-title p{
  width: 641px;
  line-height: 24px;
  font-family: Source Han Sans SC;
  font-size: 16px;
  color: #666666;
}
.research-system .research-title .advance{
  position: absolute;
  right: 0;
  bottom: 88px;
}
</style>



// WEBPACK FOOTER //
// src/components/researchSystem/ResearchSystem.vue